import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import IconWithTooltip from "components/IconWithTooltip";
import { Administrative, CircleCrossed } from "components/icons/generated";
import Box from "ds/components/Box";

const ModulesTableSettingsCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Box gap="small">
        {module.administrative && (
          <IconWithTooltip icon={Administrative} tooltip="Administrative" size="default" />
        )}
        {module.isDisabled && (
          <IconWithTooltip icon={CircleCrossed} tooltip="Disabled" size="default" />
        )}
      </Box>
    </TableSimpleCell>
  );
};

export default ModulesTableSettingsCell;
